module.exports = __webpack_public_path__ + "static/media/extra_oral_left_small.8ef79615.png";